module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCI+PHBhdGggZD0iTTg0Ljc1IDMyLjE0SDY2LjVWMjMuNWMwLTQuNDEtMy41OS04LTgtOEg0MWMtNC40MSAwLTggMy41OS04IDh2OC42NEgxNC43NWMtMi43NSAwLTUgMi4yNS01IDV2NDIuNzNjMCAyLjc1IDIuMjUgNSA1IDVoNzBjMi43NSAwIDUtMi4yNSA1LTVWMzcuMTRjMC0yLjc1LTIuMjUtNS01LTV6TTM5IDIzLjVjMC0xLjA4LjkyLTIgMi0yaDE3LjVjMS4wOCAwIDIgLjkyIDIgMnY4LjY0SDM5VjIzLjV6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/car-features/number_of_bags.svg
// module id = MiAi
// module chunks = 1